import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Card, { CardActions, CardContent } from 'material-ui/Card';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import TextField from 'material-ui/TextField';
import firebase from 'firebase';

const styles = theme => ({
  textField: {
    width: '100%',
    margin: 0,
  },
  textFieldRoot: {
    paddingTop: '10px',
    paddingBottom: '0px',
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
  },
  textFieldInput: {
    backgroundColor: theme.palette.common.white,
    fontSize: 15,
    padding: 0,
    width: 'calc(100% - 24px)',
  },
  hr: {
    border: '0',
    height: '0',
    borderTop: '1px solid rgba(0, 0, 0, 0.1)',
    borderBottom: '1px solid rgba(255, 255, 255, 0.3)',
  }
});


class EntryView extends Component {
  state = {
    text: '',
  }

  componentDidMount() {
    if (!this.props.doc.unsaved) {
      this.setState({text: this.props.doc.data().text});
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.doc.id != this.props.doc.id) {
      clearTimeout(this.saveTimeout);
      this.saveTimeout = null;

      this.saveText();
      this.setState({text: nextProps.doc.data().text});
    }

    if (nextProps.doc.data().text != this.props.doc.data().text) {
      this.setState({text: nextProps.doc.data().text});
    }
  }

  componentWillUnmount() {

  }

  startNewEntry = (text) => {
    this.props.doc.ref.set({
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      text: text,
      type: 'general',
    });
  }

  updateText = (ev) => {
    clearTimeout(this.saveTimeout);
    this.saveTimeout = null;

    console.log(this.state.text);
    console.log(ev.target.value);

    if (this.state.text == ev.target.value) {
      console.log('text is already the same');
      return;
    }

    this.setState({text: ev.target.value});

    // save after 5 seconds
    this.saveTimeout = setTimeout(this.saveText, 5000);
  }

  saveText = () => {
    console.log('saving text');
    if (this.props.doc.unsaved) {
      this.startNewEntry(this.state.text);
    } else {
      this.props.doc.ref.update({
        text: this.state.text,
        modifiedAt: firebase.firestore.FieldValue.serverTimestamp(),
      });
    }
  }

  onClick = () => {
    this.textField.focus();
  }

  render() {
    const { classes } = this.props;
    var timestamp = null
    if (!this.props.doc.unsaved && this.props.doc.data().createdAt) {
      var date = this.props.doc.data().createdAt;
      if (date.getHours() < 3) {
        date.setDate(date.getDate()-1);
        date.setHours(23);
      }

      timestamp = <Typography type="caption">{date.toLocaleDateString('en-US')}</Typography>;
    } else {
      timestamp = <Typography type="caption">Today</Typography>;
    }

    return (
      <div onClick={this.onClick}>
        {timestamp}
        <TextField
          inputRef={(textField) => {this.textField = textField}}
          className={classes.textField}
          placeholder="Start today's entry..."
          multiline
          value={this.state.text}
          className={classes.textField}
          onChange={this.updateText}
          margin="normal"

          InputProps={{
            disableUnderline: true,
            classes: {
              root: classes.textFieldRoot,
              input: classes.textFieldInput,
            },
          }}
          InputLabelProps={{
            shrink: true,
            className: classes.textFieldFormLabel,
          }}
        />
        <hr className={classes.hr} />
      </div>
    );
  }
}


EntryView.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EntryView);



// WEBPACK FOOTER //
// ./src/EntryView.js